export default __webpack_public_path__ + "6cde35b1a915321d16b339795c37b921.svg";